<template>
  <v-layout row wrap align-center>
    <div class="getInTouch-video-container">
      <video id="getInTouchVideo" muted autoplay="true" loop="true" width="1280" height="720">
        <source
          src="/img/PromotionVid.mp4"
          type="video/mp4"
        >
      </video>
      <div class="getInTouch-overlay">
        <v-layout align-center justify-center column fill-height>
          <h1 class="font-weight-bold">Ready to start your next project?</h1>
          <p class="font-weight-light font-italic">
            Every project is an opportunity to learn, to figure out
            <br>problems and challenges, to invent and reinvent.
          </p>
          <a @click="toPage('Contact Us')">Click Here To Start Your Journey</a>
        </v-layout>
      </div>
    </div>
  </v-layout>
</template>

<script>
export default {
  methods: {
    toPage(name) {
      this.$router.push({ name: name });
    }
  }
};
</script>

<style>
.getInTouch-video-container {
  position: relative;
  width: 100%;
  height: 100vh;
  overflow: hidden;
}

.getInTouch-video-container video {
  /* Make video to at least 100% wide and tall */
  min-width: 100%;
  min-height: 100%;
  /* Setting width & height to auto prevents the browser from stretching or squishing the video */
  width: auto;
  height: auto;
  /* Center the video */
  position: absolute;
  top: 50%;
  left: 50%;
  -webkit-transform: translate(-50%, -50%);
  transform: translate(-50%, -50%);
}

/* Content box for the headings and buttons */
.getInTouch-overlay {
  background-image: linear-gradient(
    to top left,
    #e9168c,
    #9012fe 50%,
    #006cff 100%
  );
  opacity: 0.8;
  position: absolute;
  top: 0;
  width: 100%;
  height: 100%;
  margin: 0;
  box-sizing: border-box;
  padding: 2%;
  line-height: 1.5;
  text-align: center;
}

.getInTouch-overlay h1 {
  color: white;
  font-size: 50pt !important;
  font-weight: bold;
  text-shadow: 0 0 0.3em #000;
}

.getInTouch-overlay p {
  color: white;
  padding: 0 15%;
  font-size: 22pt !important;
  text-shadow: 0 0 0.3em #000;
  margin: 1em 0 2em 0;
}

.getInTouch-overlay a {
  border: 0.2em solid;
  cursor: pointer;
  color: #fff;
  padding: 1em 2em;
  text-transform: uppercase;
  font-weight: bold;
  transition: 0.3s;
  margin-bottom: 15px;
}
.getInTouch-overlay a:hover {
  opacity: 1;
  background: white;
  color: black;
  border: 0 solid;
  margin-bottom: 0px;
}

@media (max-width: 960px) {
  .getInTouch-overlay h1 {
    font-size: 35pt !important;
  }
  .getInTouch-overlay p {
    font-size: 15px !important;
    padding: 0 10%;
  }
  .getInTouch-overlay a {
    font-size: 10px !important;
    padding: 1em 15px;
  }
  .getInTouch-video-container {
    /* height: 510px; */
  }
}

@media (max-width: 599px) {
  .getInTouch-overlay h1 {
    font-size: 30px !important;
  }
  .getInTouch-overlay p {
    padding: 0 5%;
  }
}

@media (min-width: 2000px) {
  .getInTouch-overlay {
    padding: 250px 10%;
  }
}
</style>
